import Vue from 'vue'
import { formatDate } from './utils'

Vue.filter('formatDate', formatDate)

export default formatDate
